<div fxLayout="row"
     fxLayoutAlign="start center"
     fxLayoutGap="12px"
     fxFlex>
  <span class="mat-subtitle-2 layout margin-left-sm secondary-text">Filters: </span>
  <span *ngIf="!filters.length"
        class="mat-caption">None</span>
  <span *ngIf="filters.length"
        fxHide
        fxShow.xs
        class="mat-caption">Applied</span>
  <mat-chip-listbox #chipList
                    fxHide.xs>
    <mat-chip *ngFor="let filter of filters"
              class="option"
              [disableRipple]="true"
              (removed)="remove(filter)">
      {{filter.name}}: {{filter.value}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-listbox>
  <button *ngIf="filters.length"
          mat-button
          (click)="clear()">CLEAR</button>
</div>
